export class AddressData {
    type: string;
    geometry: { coordinates: { 0: number; 1: number } };
    properties: { label: string; postcode: string; citycode: string; name: string; city: string };
  }